import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchJobDocuments } from "src/redux/reducers/JobDocument";
import queryString from "query-string";
import ExportForm from "../Form/ExportForm";
import { useLocation } from "react-router-dom";
import { useRecentDocument } from "src/hooks/useRecentNavigation";
import { ReduxState } from "src/redux";

export const Forms = () => {
  const dispatch = useDispatch();
  const location = useLocation();

  const { selectedL1, selectedL2 } = useSelector(
    (state: ReduxState) => state.TagLevel
  );

  // Track this page view as a recent document
  useRecentDocument(
    selectedL1 && selectedL2
      ? {
          docType: "forms",
          label: `Forms - ${selectedL2}`,
          icon: "file-alt",
          l1: selectedL1,
          l2: selectedL2,
        }
      : null
  );

  React.useEffect(() => {
    const { l1, l2 } = queryString.parse(location.search);
    // console.log("1");
    dispatch(
      fetchJobDocuments({
        fieldName: "formMode",
      })
    );
  }, [location.search, dispatch]);

  return <ExportForm />;
};
